/**
 * Created by Ning Jiang on 3/20/2017.
 */

import {BookOfShadowsServerDataParser} from "../BookOfShadowsServerDataParser";
import {IBookOfShadowGameData, ILockedReelsDetails} from "./IBookOfShadowsServerData";
import {SpinParsedGameData} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinParsedServerData";
import {IBetLineWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";

export class BookOfShadowsParsedGameData extends SpinParsedGameData {
    private readonly _fsNumberOfSpins: number[] = [];
    private readonly _fsSpecialSymbol: string = "";
    private readonly _selectedRows: number;
    private readonly _fsSymbolPosition: number[];
    private readonly _scatterWins: IBetLineWinData[];
    private readonly _featureBuyRows: number;
    private readonly _playerChoseRedrawSymbol: boolean;
    private readonly _lockedReelDetails: ILockedReelsDetails[];
    private readonly _allowLockedReelsNextSpin: boolean;
    private readonly _actualBetThisSpin: number;

    constructor(rawData: IBookOfShadowGameData, dataParser: BookOfShadowsServerDataParser) {
        super(rawData, dataParser);

        this._fsNumberOfSpins = dataParser.parseFsNumberOfSpins(rawData);
        this._fsSpecialSymbol = dataParser.parseFsSpecialSymbol(rawData);
        this._selectedRows = dataParser.parseSelectedRowsBaseGame(rawData);
        this._selectedRowsFS = dataParser.parseSelectedRowsFS(rawData);
        this._fsSymbolPosition = dataParser.parseFsSymbolPosition(rawData);
        this._scatterWins = dataParser.parseScatterWins(rawData);
        this._featureBuyRows = dataParser.parseFeatureBuyRows(rawData);
        this._playerChoseRedrawSymbol = dataParser.parsePlayerChoseRedrawSymbol(rawData);
        this._allowLockedReelsNextSpin = dataParser.parseAllowLockedReelsNextSpin(rawData);

        this._lockedReelDetails = rawData.lockedReelDetails;

        // #331
        this._actualBetThisSpin = dataParser.parseActualBetThisSpin(rawData);
    }

    get allowLockedReelsNextSpin(): boolean {
        return this._allowLockedReelsNextSpin;
    }

    get lockedReelDetails(): ILockedReelsDetails[] {
        return this._lockedReelDetails;
    }

    get fsNumberOfSpins(): number[] {
        return this._fsNumberOfSpins;
    }

    get fsSpecialSymbol(): string {
        return this._fsSpecialSymbol;
    }

    get selectedRows(): number {
        return this._selectedRows;
    }

    private _selectedRowsFS: number;

    get selectedRowsFS(): number {
        return this._selectedRowsFS;
    }

    get fsSymbolPosition(): number[] {
        return this._fsSymbolPosition;
    }

    get scatterWins(): IBetLineWinData[] {
        return this._scatterWins;
    }

    get featureBuyRows(): number {
        return this._featureBuyRows;
    }

    get playerChooseRedrawSymbol(): boolean {
        return this._playerChoseRedrawSymbol;
    }

    get actualBetThisSpin(): number {
        return this._actualBetThisSpin;
    }
}